import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 竞拍-模块
 */

var auction = {
  path: '/auction',
  redirect: '/auction/find',
  component: BasicLayout,
  children: [// 品牌馆市场
  {
    path: 'brandMarket',
    name: 'BrandMarket',
    component: function component() {
      return import('views/market/brandMarket');
    },
    meta: {
      title: 'NFR市场',
      keepAlive: true
    }
  }, // 专题市场
  {
    path: 'themeMarket',
    name: 'ThemeMarket',
    component: function component() {
      return import('views/market/themeMarket');
    },
    meta: {
      title: '专题市场' // hasNoHead: true

    }
  }, // 购物车市场
  {
    path: 'cartMarket',
    name: 'CartMarket',
    component: function component() {
      return import('views/market/cartMarket');
    },
    meta: {
      title: '购物车市场' // hasNoHead: true

    }
  }, {
    path: 'searchResult',
    name: 'SearchResult',
    component: function component() {
      return import('views/search/searchResult');
    },
    meta: {
      title: '搜索结果',
      keepAlive: true
    }
  }, {
    path: 'detail/:id',
    name: 'AuctionDetail',
    component: function component() {
      return import('views/auction/Detail');
    },
    meta: {
      title: '资产详情',
      keepAlive: true
    }
  }, {
    path: 'detailList/:id',
    name: 'DetailList',
    component: function component() {
      return import('views/auction/DetailList');
    },
    meta: {
      title: '流转信息'
    }
  }, {
    path: 'AuctionRecord',
    name: 'AuctionRecord',
    component: function component() {
      return import('views/auction/AuctionRecord');
    },
    meta: {
      title: '竞价记录'
    }
  }, {
    path: 'InSettlement',
    name: 'InSettlement',
    component: function component() {
      return import('views/auction/InSettlement');
    },
    meta: {
      title: '结算中'
    }
  }, {
    path: 'payCallBack',
    name: 'payCallBack',
    component: function component() {
      return import('views/auction/PayCallBack');
    },
    meta: {
      title: '交易结果'
    }
  }, {
    path: 'MyBidding',
    name: 'MyBidding',
    component: function component() {
      return import('views/auction/MyBidding');
    },
    meta: {
      title: '我的订单'
    }
  }, {
    path: 'AuctionPayOrder',
    name: 'AuctionPayOrder',
    component: function component() {
      return import('views/auction/AuctionPayOrder');
    },
    meta: {
      title: '确认订单'
    }
  }, {
    path: 'AudioPlay',
    name: 'AudioPlay',
    component: function component() {
      return import('views/auction/AudioPlay');
    },
    meta: {
      title: '音频播放'
    }
  }, {
    path: '/RightsList/:id',
    name: 'RightsList',
    component: function component() {
      return import('views/auction/Rights/RightsList');
    },
    meta: {
      title: '失效权益'
    }
  }, {
    path: '/privilegeInfo/:id',
    name: 'PrivilegeInfo',
    component: function component() {
      return import('views/auction/Rights/PrivilegeInfo');
    },
    meta: {
      title: '权益详情',
      hasNoHead: true
    }
  }, {
    path: '/virtualCode/:id',
    name: 'VirtualCode',
    component: function component() {
      return import('views/auction/Rights/VirtualCode');
    },
    meta: {
      title: '我的兑换'
    }
  }, {
    path: '/exchangeDetail/:id',
    name: 'ExchangeDetail',
    component: function component() {
      return import('views/auction/Rights/ExchangeDetail');
    },
    meta: {
      title: '我的兑换'
    }
  }, {
    path: '/rightOrder',
    name: 'ExchangeRightOrder',
    component: function component() {
      return import('@/views/auction/Rights/RightOrder');
    },
    meta: {
      title: '确认订单'
    }
  }, {
    path: '/aliPayCallBack',
    name: 'AliPayCallBack',
    component: function component() {
      return import('views/auction/AliPayCallBack');
    },
    meta: {
      title: '支付宝支付'
    }
  }, {
    path: '/collectorsIndex',
    name: 'CollectorsIndex',
    component: function component() {
      return import('views/auction/Rank/collectorsIndex');
    },
    meta: {
      title: '',
      keepAlive: true
    }
  }, {
    path: '/firstRights',
    name: 'FirstRights',
    component: function component() {
      return import('views/auction/Rights/FirstRights');
    },
    meta: {
      title: '选择权益'
    }
  }, {
    path: '/calendar',
    name: 'Calendar',
    component: function component() {
      return import('@/views/auction/Calendar/Calendar');
    },
    meta: {
      title: '平台日历',
      keepAlive: true
    }
  }, {
    path: '/auction/bankValid',
    name: 'BankValid',
    component: function component() {
      return import('views/auction/Bank/Valid');
    },
    meta: {
      title: '银行卡验证'
    }
  }, {
    path: '/auction/bankValidResult',
    name: 'BankValidResult',
    component: function component() {
      return import('views/auction/Bank/Result');
    },
    meta: {
      title: '银行卡验证'
    }
  }, {
    path: '/auction/bankSmsCode',
    name: 'BankSmsCode',
    component: function component() {
      return import('views/auction/Bank/SmsCode');
    },
    meta: {
      title: '确认支付'
    }
  }]
};
export default auction;